// extracted by mini-css-extract-plugin
export default {"Icon":"Icon3_D2ysxFZ_ll","Icon-wrapper":"Icon-wrapper2z2wVIeGsiUy","Icon-empty":"Icon-empty6PuNZVw0joPv","Icon-svg":"Icon-svg2Lm7f6G9Ly5a"};